import { Client } from '@/types/clients'

const clients: Client[] = [
  { organisation: 'AECOM', location: 'USA' },
  { organisation: 'Aqaba Development Corporation', location: 'Jordan' },
  { organisation: 'Arup', location: 'UK' },
  { organisation: 'Asian Development Bank', location: 'Sulawesi Sea' },
  { organisation: 'Autoridad Portuaria de Gijón', location: 'Spain' },
  { organisation: 'Baltic Coal Terminal', location: 'Latvia' },
  { organisation: 'BP Shipping', location: 'UK' },
  { organisation: 'British Maritime Technology', location: 'UK' },
  { organisation: 'CSAV', location: 'Chile' },
  { organisation: 'Caledonian MacBrayne', location: 'UK' },
  { organisation: 'Canada Maritime', location: 'Canada' },
  { organisation: 'Chennai Port Trust', location: 'India' },
  { organisation: 'County Nat West Ventures', location: 'UK' },
  { organisation: 'Dar Al-Handasah Consultants', location: 'Lebanon' },
  { organisation: 'Degere Group', location: 'Turkey' },
  { organisation: 'Department of Environment, Transport and Regions', location: 'UK' },
  { organisation: 'Department for International Development', location: 'UK' },
  { organisation: 'Devonport Management Limited', location: 'UK' },
  { organisation: 'Dover Harbour Board', location: 'UK' },
  { organisation: 'Dublin Port Corporation', location: 'Ireland' },
  { organisation: 'EU TACIS, Phare, DGTREN (DG VII), Interreg', location: 'Belgium' },
  { organisation: 'European Liner Affairs Association (ELAA)', location: 'Belgium' },
  { organisation: 'Eurotunnel', location: 'UK' },
  { organisation: 'FINESSE partnership', location: 'UK Belgium France' },
  { organisation: 'High-Point Rendel', location: 'UK' },
  { organisation: 'GHK', location: 'UK' },
  { organisation: 'Gujarat Pipavav Ports Limited', location: 'India' },
  { organisation: 'Hamburg, Bremen, Niedersachsen', location: 'Germany' },
  { organisation: 'HHLA Hamburg', location: 'Germany' },
  { organisation: 'Hochtief', location: 'Germany' },
  { organisation: 'Hong Kong Port and Maritime Board', location: 'Hong Kong' },
  { organisation: 'ICTSI', location: 'Philippines' },
  { organisation: 'Independent Port Capital Management', location: 'Spain' },
  { organisation: 'Intercontainer/Interfrigo', location: 'Switzerland' },
  { organisation: 'Inter Forward', location: 'UK' },
  { organisation: 'Interpool-Traclease', location: 'USA' },
  { organisation: 'Izar Shipyard', location: 'Spain' },
  { organisation: 'JASPERS (Joint Assistance to Support Projects in European Regions)', location: 'Poland' },
  { organisation: 'Jafza (Jebel Ali Free Zone)', location: 'UAE' },
  { organisation: 'Jawahrlal Nehru Port Trust', location: 'India' },
  { organisation: 'JETRO', location: 'Japan' },
  { organisation: 'Maersk Line', location: 'Denmark' },
  { organisation: 'MAHART', location: 'Hungary' },
  { organisation: 'Ministry of National Economy', location: 'Oman' },
  { organisation: 'Mizuho Bank', location: 'Japan' },
  { organisation: 'Mobil Oil', location: 'UK' },
  { organisation: 'Mouchel', location: 'UK' },
  { organisation: 'Nikko Bank', location: 'Japan' },
  { organisation: 'Nissho Iwai Bank', location: 'Japan' },
  { organisation: 'Panama Canal Authority', location: 'Panama' },
  { organisation: 'Planco', location: 'Germany' },
  { organisation: 'Powell Duffryn Rail Projects', location: 'UK' },
  { organisation: 'Port of Barcelona Authority', location: 'Spain' },
  { organisation: 'Portland Port Limited', location: 'UK' },
  { organisation: 'Price Waterhouse', location: 'USA' },
  { organisation: 'Railfreight Distribution, Trainload Freight, British Rail', location: 'UK' },
  { organisation: 'Ramboll', location: 'Black Sea' },
  { organisation: 'Redcar & Cleveland Borough Council', location: 'UK' },
  { organisation: 'Reliance Group', location: 'USA' },
  { organisation: 'Rolls-Royce', location: 'UK' },
  { organisation: 'SNCF', location: 'France' },
  { organisation: 'Sea Containers Service', location: 'Bermuda' },
  { organisation: 'Shell International Trading and Shipping', location: 'UK' },
  { organisation: 'Sri Lanka Ports Trust', location: 'Sri Lanka' },
  { organisation: 'Suez Canal Authority', location: 'Egypt' },
  { organisation: 'Tanzania Ports Authority', location: 'Tanzania' },
  { organisation: 'Teesport', location: 'UK' },
  { organisation: 'Thanet District Council', location: 'UK' },
  { organisation: 'Thomas Miller: Through Transport Club: Neptunus Services', location: 'UK' },
  { organisation: 'Tiphook Container Rental/Tiphook Tank Rental', location: 'UK' },
  { organisation: 'Transamerica Leasing', location: 'USA' },
  { organisation: 'Transnet', location: 'South Africa' },
  { organisation: 'Trencor', location: 'South Africa' },
  { organisation: 'URS (Scott Wilson)', location: 'UK' },
  { organisation: 'V.Ships', location: 'Monaco' }
]

export default clients
